(() => {
  const ATTRIBUTE_GIFT = 'Plantero Hediye';
  const ATTRIBUTE_TIER = 'Plantero Hediye Kademesi';
  const ATTRIBUTE_CAMPAIGN = 'Plantero Hediye Kampanyası';
  const ATTRIBUTE_MODE = 'Plantero Avantaj';
  const ATTRIBUTE_DISCOUNT = 'Plantero İndirim';
  const CHOICE_STORAGE_KEY = 'plantero-gift-tier-one-choice';
  const MODE_STORAGE_KEY = 'plantero-cart-reward-mode';

  const createMedia = (option, className) => {
    const media = document.createElement('span');
    media.className = className;

    if (option?.type === 'discount') {
      media.classList.add('pl-gift__discount-media');
      media.textContent = '₺';
      return media;
    }

    if (option?.image) {
      const image = document.createElement('img');
      image.src = option.image;
      image.alt = option.name || 'Sepet hediyesi';
      image.loading = 'lazy';
      image.width = 180;
      image.height = 180;
      media.appendChild(image);
      return media;
    }

    media.classList.add('pl-gift__media-fallback');
    media.textContent = (option?.name || 'H').trim().slice(0, 2).toLocaleUpperCase('tr-TR');
    return media;
  };

  const appendMessagePart = (target, text, className) => {
    const part = className ? document.createElement('strong') : document.createTextNode(text);
    if (className) {
      part.className = className;
      part.textContent = text;
    }
    target.appendChild(part);
  };

  class PlanteroGiftCampaignElement extends HTMLElement {
    connectedCallback() {
      const configNode = this.querySelector('[data-pl-gift-config]');
      if (!configNode) return;

      try {
        this.config = JSON.parse(configNode.textContent);
      } catch (error) {
        console.error('Plantero hediye ayarları okunamadı.', error);
        return;
      }

      window.PlanteroGiftCampaign?.register(this);
    }

    disconnectedCallback() {
      window.PlanteroGiftCampaign?.unregister(this);
    }

    render({ cart, total, tier, tierIndex, selectedGift, nextTier, error, busy }) {
      if (!this.config) return;

      this.renderMessage({ total, tier, selectedGift, nextTier, error, busy });
      this.renderProgress({ total, tierIndex, selectedGift });
      this.renderChoice({ tier, selectedGift, busy });

      const hint = this.querySelector('[data-pl-gift-hint]');
      const choiceRequired = Boolean(tier && tier.options.length > 1 && !selectedGift);
      hint.classList.toggle('is-warning', choiceRequired || Boolean(error));
      hint.textContent = error || (busy
        ? 'Seçimin güncelleniyor…'
        : choiceRequired
          ? 'Ödeme adımına geçmek için hediyeni veya indirimini seç.'
          : selectedGift?.type === 'discount'
            ? 'İndirim bu siparişin toplamından düşülür. Hediye ile birlikte kullanılamaz.'
            : this.config.discountsEnabled
              ? 'Bu kademeden yalnızca bir avantaj seçilir. Sepet değiştikçe kademen güncellenir.'
              : 'Sepet tutarın değiştiğinde hediye kademen otomatik güncellenir.');

      this.dataset.cartItemCount = String(cart.item_count || 0);
    }

    renderMessage({ total, tier, selectedGift, nextTier, error, busy }) {
      const message = this.querySelector('[data-pl-gift-message]');
      message.replaceChildren();
      if (busy || error) {
        appendMessagePart(message, busy ? 'Avantajın güncelleniyor…' : '⚠️ Seçimin uygulanamadı. Aşağıdan yeniden seç.');
        return;
      }

      const tiers = [...this.config.tiers].sort((a, b) => a.threshold - b.threshold);
      if (!tier) {
        const remaining = Math.max(0, tiers[0].threshold - total);
        appendMessagePart(message, this.config.discountsEnabled ? '✨ İlk hediye veya indirimine sadece ' : '✨ İlk hediyene sadece ');
        appendMessagePart(message, window.PlanteroGiftCampaign.formatMoney(remaining), 'pl-gift__message-accent');
        appendMessagePart(message, ' kaldı');
        return;
      }

      if (tier.options.length > 1 && !selectedGift) {
        const discount = tier.options.find((option) => option.type === 'discount');
        if (discount) {
          appendMessagePart(message, '🎉 Hakkın hazır! Hediye ya da ');
          appendMessagePart(message, window.PlanteroGiftCampaign.formatMoney(discount.amount, false), 'pl-gift__message-accent');
          appendMessagePart(message, ' indirim seç.');
          return;
        }
        appendMessagePart(message, this.config.discountsEnabled ? '🎉 Hediye veya indirim hakkın hazır! ' : '🎉 Hediyeni kazandın! ');
        appendMessagePart(message, tier.label, 'pl-gift__message-accent');
        appendMessagePart(message, ' arasından seçimini yap');
        return;
      }

      appendMessagePart(message, '✨ ');
      appendMessagePart(message, selectedGift?.name || tier.label, 'pl-gift__message-accent');
      appendMessagePart(message, selectedGift?.type === 'discount' ? ' bu siparişine uygulanır!' : ' hediyen hazır!');

      if (nextTier) {
        const remaining = Math.max(0, nextTier.threshold - total);
        appendMessagePart(message, ' Sıradaki ');
        appendMessagePart(message, this.config.discountsEnabled ? `${window.PlanteroGiftCampaign.formatMoney(nextTier.threshold, false)} kademesi` : nextTier.label, 'pl-gift__message-accent');
        appendMessagePart(message, ' için ');
        appendMessagePart(message, window.PlanteroGiftCampaign.formatMoney(remaining), '');
        appendMessagePart(message, ' kaldı');
      } else {
        appendMessagePart(message, ' En üst kademeye ulaştın.');
      }
    }

    renderProgress({ total, tierIndex, selectedGift }) {
      const tiers = [...this.config.tiers].sort((a, b) => a.threshold - b.threshold);
      const nodes = this.querySelector('[data-pl-gift-nodes]');
      const fill = this.querySelector('[data-pl-gift-fill]');
      nodes.replaceChildren();
      const firstPosition = tiers.length > 1 ? 100 / (tiers.length + 1) : 50;
      const positionStep = tiers.length > 1 ? (100 - firstPosition) / (tiers.length - 1) : 0;
      const positions = tiers.map((_, index) => firstPosition + positionStep * index);

      tiers.forEach((tier, index) => {
        const node = document.createElement('div');
        const stateClass =
          index < tierIndex ? 'is-passed' : index === tierIndex ? 'is-active' : 'is-locked';
        node.className = `pl-gift__node ${stateClass}`;
        node.style.left = `${positions[index]}%`;

        const markerOption = index === tierIndex && selectedGift ? selectedGift : tier.options[0];
        node.appendChild(createMedia(markerOption, 'pl-gift__node-media'));

        const amount = document.createElement('span');
        amount.className = 'pl-gift__node-amount';
        amount.textContent = window.PlanteroGiftCampaign.formatMoney(tier.threshold, false);
        node.appendChild(amount);

        const label = document.createElement('span');
        label.className = 'pl-gift__node-label';
        label.textContent = index === tierIndex && selectedGift ? selectedGift.name : tier.label;
        node.appendChild(label);
        nodes.appendChild(node);
      });

      let progressPercent = 0;
      if (tiers.length && total <= tiers[0].threshold) {
        progressPercent = (total / tiers[0].threshold) * positions[0];
      } else {
        for (let index = 1; index < tiers.length; index += 1) {
          const previousTier = tiers[index - 1];
          const currentTier = tiers[index];
          if (total <= currentTier.threshold) {
            const tierProgress =
              (total - previousTier.threshold) / (currentTier.threshold - previousTier.threshold);
            progressPercent =
              positions[index - 1] + tierProgress * (positions[index] - positions[index - 1]);
            break;
          }
        }

        if (tiers.length && total >= tiers[tiers.length - 1].threshold) {
          progressPercent = 100;
        }
      }

      const progress = Math.min(1, Math.max(0, progressPercent / 100));
      fill.style.setProperty('--pl-gift-progress', String(progress));
    }

    renderChoice({ tier, selectedGift, busy }) {
      const choice = this.querySelector('[data-pl-gift-choice]');
      choice.replaceChildren();

      if (!tier || tier.options.length < 2) {
        choice.hidden = true;
        return;
      }

      choice.hidden = false;
      const title = document.createElement('p');
      title.className = 'pl-gift__choice-title';
      title.textContent = this.config.discountsEnabled ? 'Hediye veya indirim seç' : 'Hediyeni seç';
      choice.appendChild(title);

      const grid = document.createElement('div');
      grid.className = 'pl-gift__choice-grid';

      tier.options.forEach((option) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pl-gift__choice-button';
        button.classList.toggle('pl-gift__choice-discount', option.type === 'discount');
        button.disabled = Boolean(busy);
        button.classList.toggle('is-selected', selectedGift?.name === option.name);
        button.setAttribute('aria-pressed', selectedGift?.name === option.name ? 'true' : 'false');
        button.appendChild(createMedia(option, 'pl-gift__choice-media'));

        const name = document.createElement('span');
        name.className = 'pl-gift__choice-name';
        name.textContent = option.name;
        button.appendChild(name);
        button.addEventListener('click', () => window.PlanteroGiftCampaign.selectGift(tier, option));
        grid.appendChild(button);
      });

      choice.appendChild(grid);
    }

  }

  class PlanteroGiftCampaignController {
    constructor() {
      this.elements = new Set();
      this.cart = null;
      this.config = null;
      this.refreshTimer = null;
      this.syncing = false;
      this.bound = false;
      this.error = '';
      this.pendingRefresh = false;
      this.selecting = false;
      this.failedStateKey = '';
      this.requestedChoice = null;
      this.refreshing = false;
    }

    register(element) {
      this.elements.add(element);
      this.config ||= element.config;
      this.bind();
      this.scheduleRefresh(0);
    }

    unregister(element) {
      this.elements.delete(element);
    }

    bind() {
      if (this.bound) return;
      this.bound = true;

      document.addEventListener('plantero:cart-updated', () => this.scheduleRefresh(30));
      document.addEventListener('shopify:section:load', () => this.scheduleRefresh(30));
      window.addEventListener('pageshow', () => this.scheduleRefresh(30));

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.scheduleRefresh(30));
      }
    }

    scheduleRefresh(delay = 80) {
      window.clearTimeout(this.refreshTimer);
      this.refreshTimer = window.setTimeout(() => this.refresh(), delay);
    }

    async refresh() {
      if (!this.elements.size) return;
      if (this.syncing || this.selecting || this.refreshing) {
        this.pendingRefresh = true;
        return;
      }
      this.refreshing = true;
      if (this.cart) this.render(this.getState());

      try {
        const response = await fetch(`${window.routes.cart_url}.js`, {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error(`Sepet okunamadı: ${response.status}`);
        this.cart = await response.json();
        await this.reconcile();
      } catch (error) {
        this.error = 'Sepet okunamadı. Lütfen sayfayı yenileyip tekrar deneyin.';
        if (this.cart) this.render(this.getState());
        console.error('Plantero hediye kampanyası güncellenemedi.', error);
      } finally {
        this.refreshing = false;
        if (this.cart) this.render(this.getState());
        if (this.pendingRefresh) {
          this.pendingRefresh = false;
          this.scheduleRefresh(30);
        }
      }
    }

    getCampaignCodes() {
      return new Set((this.config?.discountCodes || []).map((code) => String(code).toUpperCase()));
    }

    getDiscountCodes() {
      return (this.cart?.discount_codes || [])
        .map((discount) => String(discount.code || '').toUpperCase())
        .filter(Boolean);
    }

    getDiscountApplications() {
      // Shopify GET returns applications directly; a bundled POST response
      // wraps each one in { amount, discount_application }.
      return (this.cart?.cart_level_discount_applications || [])
        .map((entry) => entry.discount_application || entry);
    }

    getDiscountAmount(code) {
      return this.getDiscountApplications()
        .filter((discount) => String(discount.title || '').toUpperCase() === String(code).toUpperCase())
        .reduce((amount, discount) => amount + Number(discount.total_allocated_amount || 0), 0);
    }

    getTotal() {
      if (!this.cart) return 0;
      const subtotal = this.config?.basis === 'original'
        ? Number(this.cart.original_total_price || 0)
        : Number(this.cart.total_price || 0);
      const giftSubtotal = this.getGiftItems().reduce((total, item) => {
        const linePrice =
          this.config?.basis === 'original' ? item.original_line_price : item.final_line_price;
        return total + Number(linePrice || 0);
      }, 0);

      const campaignCodes = this.getCampaignCodes();
      const ownDiscount = this.config?.basis === 'original' ? 0 :
        this.getDiscountApplications()
          .filter((discount) => campaignCodes.has(String(discount.title || '').toUpperCase()))
          .reduce((amount, discount) => amount + Number(discount.total_allocated_amount || 0), 0);

      // Keep the customer at 2,500 TL after selecting the 200 TL benefit.
      // Other discounts stay deducted; only this campaign is added back.
      return Math.max(0, subtotal + ownDiscount - giftSubtotal);
    }

    getGiftVariantIds() {
      return new Set(
        (this.config?.tiers || [])
          .flatMap((tier) => tier.options || [])
          .map((option) => Number(option.variantId || 0))
          .filter(Boolean),
      );
    }

    getGiftItems() {
      const giftVariantIds = this.getGiftVariantIds();
      return (this.cart?.items || []).filter((item) => {
        return (
          String(item.properties?._plantero_gift || '') === 'true' ||
          giftVariantIds.has(Number(item.variant_id || item.id || 0))
        );
      });
    }

    getState() {
      const tiers = [...(this.config?.tiers || [])]
        .map((tier) => ({
          ...tier,
          options: (tier.options || []).filter(
            (option) => option.name && (Number(option.variantId || 0) > 0 ||
              (this.config.discountsEnabled && this.cart?.currency === 'TRY' &&
                option.type === 'discount' && option.code && Number(option.amount) > 0)),
          ),
        }))
        .filter((tier) => tier.threshold > 0 && tier.options.length)
        .sort((a, b) => a.threshold - b.threshold);
      const total = this.getTotal();
      let tierIndex = -1;

      tiers.forEach((tier, index) => {
        if (total >= tier.threshold) tierIndex = index;
      });

      const tier = tierIndex >= 0 ? tiers[tierIndex] : null;
      const nextTier = tiers[tierIndex + 1] || null;
      const currentGiftName = String(this.cart?.attributes?.[ATTRIBUTE_GIFT] || '');
      let selectedGift = tier?.options.find((option) => option.name === currentGiftName) || null;
      let rememberedMode = '';
      try {
        rememberedMode = window.localStorage.getItem(MODE_STORAGE_KEY) || '';
      } catch (error) {
        // Cart attributes remain the persistent source when storage is unavailable.
      }
      const mode = this.requestedChoice
        ? (this.requestedChoice.type === 'discount' ? 'discount' : 'gift')
        : this.cart?.attributes?.[ATTRIBUTE_MODE] || (currentGiftName ? 'gift' : rememberedMode);
      const campaignCodes = this.getCampaignCodes();
      const hasCampaignCode = this.getDiscountCodes().some((code) => campaignCodes.has(code));
      if (mode === 'discount' || (!mode && !currentGiftName && hasCampaignCode)) {
        selectedGift = tier?.options.find((option) => option.type === 'discount') || null;
      } else if (this.requestedChoice) {
        selectedGift = tier?.options.find((option) => option.name === this.requestedChoice.name && option.type !== 'discount') || null;
      }

      if (tier?.options.length === 1) {
        selectedGift = tier.options[0];
      } else if (tier?.options.length > 1 && !selectedGift) {
        try {
          const remembered = window.localStorage.getItem(CHOICE_STORAGE_KEY);
          selectedGift = tier.options.find((option) => option.name === remembered) || null;
        } catch (error) {
          selectedGift = null;
        }
      }
      // Preserve automatic Shaker/Termos selection unless the customer chose
      // the discount alternative. Tier one still offers two physical choices.
      if (tierIndex > 0 && !selectedGift) {
        selectedGift = tier.options.find((option) => option.type !== 'discount') || null;
      }

      return { tiers, total, tier, tierIndex, nextTier, selectedGift };
    }

    async reconcile() {
      const state = this.getState();
      if (this.error && this.failedStateKey === `${state.total}:${state.selectedGift?.code || state.selectedGift?.variantId || ''}`) {
        this.render(state);
        return;
      }
      const isDiscount = state.selectedGift?.type === 'discount';
      const expectedGift = isDiscount ? '' : state.selectedGift?.name || '';
      const expectedTier = state.tier ? String(state.tier.threshold / 100) : '';
      const currentGift = String(this.cart.attributes?.[ATTRIBUTE_GIFT] || '');
      const currentTier = String(this.cart.attributes?.[ATTRIBUTE_TIER] || '');
      const expectedVariantId = Number(state.selectedGift?.variantId || 0);
      const giftItems = this.getGiftItems();
      const expectedCode = isDiscount ? String(state.selectedGift.code).toUpperCase() : '';
      const ownCodes = this.getDiscountCodes().filter((code) => this.getCampaignCodes().has(code));
      const codesMatch = expectedCode ? ownCodes.length === 1 && ownCodes[0] === expectedCode : !ownCodes.length;
      const expectedMode = state.selectedGift ? (isDiscount ? 'discount' : 'gift') : '';
      const giftLinesMatch = expectedVariantId
        ? giftItems.length === 1 &&
          Number(giftItems[0].variant_id || giftItems[0].id || 0) === expectedVariantId &&
          Number(giftItems[0].quantity || 0) === 1
        : giftItems.length === 0;

      if (
        !giftLinesMatch ||
        expectedGift !== currentGift ||
        expectedTier !== currentTier ||
        !codesMatch ||
        (this.config.discountsEnabled && String(this.cart.attributes?.[ATTRIBUTE_MODE] || '') !== expectedMode)
      ) {
        await this.syncCampaign(state);
        return;
      }

      this.error = isDiscount && this.getDiscountAmount(expectedCode) !== Number(state.selectedGift.amount)
        ? 'Kampanya indirimi uygulanamadı. Başka bir indirimle birlikte kullanılamaz. Hediye seçebilir veya indirim kodlarını ödeme adımında kontrol edebilirsin.'
        : '';
      this.render(state);
    }

    getSectionsToRender() {
      const cartDrawer = document.querySelector('cart-drawer');
      const cartItems = document.querySelector('cart-items');
      const sections = new Set();

      cartDrawer?.getSectionsToRender?.().forEach((section) => {
        sections.add(section.section || section.id);
      });
      cartItems?.getSectionsToRender?.().forEach((section) => {
        sections.add(section.section || section.id);
      });

      if (!sections.size) {
        ['cart-icon-bubble', 'main-cart-items', 'main-cart-footer'].forEach((id) =>
          sections.add(id),
        );
      }

      return [...sections];
    }

    async postCart(url, body) {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || `Sepet güncellenemedi: ${response.status}`);
      }
      return response.json();
    }

    renderCartSections(cartState) {
      if (!cartState?.sections) return;

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer?.classList.contains('active') && cartDrawer.renderContents) {
        cartDrawer.renderContents(cartState);
      }

      const cartItems = document.querySelector('cart-items');
      if (cartItems?.getSectionsToRender && cartItems.getSectionInnerHTML) {
        cartItems.getSectionsToRender().forEach((section) => {
          const sectionHtml = cartState.sections[section.section];
          const sectionRoot = document.getElementById(section.id);
          if (!sectionHtml || !sectionRoot) return;
          if (
            section.id === 'cart-icon-bubble' &&
            sectionRoot.classList.contains('pl-hdr__cart')
          ) {
            return;
          }

          const target = sectionRoot.querySelector(section.selector) || sectionRoot;
          target.innerHTML = cartItems.getSectionInnerHTML(sectionHtml, section.selector);
        });
      }
    }

    async syncCampaign(state) {
      if (this.syncing) return;
      this.syncing = true;
      this.error = '';
      this.failedStateKey = '';
      this.render(state);

      try {
        const selectedGift = state.selectedGift;
        const isDiscount = selectedGift?.type === 'discount';
        const expectedVariantId = Number(selectedGift?.variantId || 0);
        const expectedTier = state.tier ? String(state.tier.threshold / 100) : '';
        const giftItems = this.getGiftItems();
        const matchingLine =
          giftItems.length === 1 &&
          Number(giftItems[0].variant_id || giftItems[0].id || 0) === expectedVariantId &&
          Number(giftItems[0].quantity || 0) === 1;

        if (!matchingLine && giftItems.length) {
          const updates = {};
          giftItems.forEach((item) => {
            updates[item.key] = 0;
          });
          this.cart = await this.postCart(`${window.routes.cart_update_url}.js`, { updates });
        }

        const campaignCodes = this.getCampaignCodes();
        const existingCodes = this.getDiscountCodes();
        const otherCodes = existingCodes.filter((code) => !campaignCodes.has(code));
        const desiredCodes = isDiscount ? [...otherCodes, String(selectedGift.code).toUpperCase()] : otherCodes;
        const codesChanged = [...existingCodes].sort().join(',') !== [...desiredCodes].sort().join(',');
        // Remove OUR coupon before adding a physical gift. Leave unrelated
        // customer codes intact. Discount changes can also change line keys.
        if (!isDiscount && codesChanged) {
          this.cart = await this.postCart(`${window.routes.cart_update_url}.js`, {
            discount: desiredCodes.join(','),
          });
        }

        if (expectedVariantId && !matchingLine) {
          await this.postCart(`${window.routes.cart_add_url}.js`, {
            items: [
              {
                id: expectedVariantId,
                quantity: 1,
                properties: {
                  _plantero_gift: 'true',
                  'Hediye': selectedGift.name,
                  'Hediye Kademesi': `${expectedTier} TL`,
                },
              },
            ],
          });
        }

        const cartState = await this.postCart(`${window.routes.cart_update_url}.js`, {
          ...(isDiscount && codesChanged ? { discount: desiredCodes.join(',') } : {}),
          attributes: {
            [ATTRIBUTE_GIFT]: isDiscount ? '' : selectedGift?.name || '',
            [ATTRIBUTE_TIER]: expectedTier,
            [ATTRIBUTE_CAMPAIGN]: selectedGift ? 'Aktif' : '',
            ...(this.config.discountsEnabled ? {
              [ATTRIBUTE_MODE]: selectedGift ? (isDiscount ? 'discount' : 'gift') : '',
              [ATTRIBUTE_DISCOUNT]: isDiscount ? this.formatMoney(selectedGift.amount, false) : '',
            } : {}),
          },
          sections: this.getSectionsToRender(),
          sections_url: window.location.pathname,
        });

        this.cart = cartState;
        this.requestedChoice = null;
        if (isDiscount && this.getDiscountAmount(selectedGift.code) !== Number(selectedGift.amount)) {
          this.error = 'Kampanya indirimi uygulanamadı. Hediye seçebilir veya indirim kodlarını ödeme adımında kontrol edebilirsin.';
          this.failedStateKey = `${state.total}:${selectedGift.code}`;
        }
        this.renderCartSections(cartState);
      } catch (error) {
        this.error = 'Seçimin güncellenemedi. Lütfen tekrar dene; ürün adetlerini değiştirmeye devam edebilirsin.';
        this.failedStateKey = `${state.total}:${state.selectedGift?.code || state.selectedGift?.variantId || ''}`;
        console.error('Plantero hediye ürünü sepete eklenemedi.', error);
      } finally {
        this.syncing = false;
        this.render(this.getState());
        if (this.pendingRefresh && !this.selecting) {
          this.pendingRefresh = false;
          this.scheduleRefresh(30);
        }
      }
    }

    async selectGift(tier, option) {
      if (this.syncing || this.selecting || this.refreshing) return;
      if (!tier?.options?.some((item) => item.name === option?.name)) return;
      this.selecting = true;
      this.error = '';
      this.failedStateKey = '';
      this.requestedChoice = option;
      this.render(this.getState());
      try {
        const response = await fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`Sepet okunamadı: ${response.status}`);
        this.cart = await response.json();
        const state = this.getState();
        state.selectedGift = state.tier?.options.find((item) => item.name === option.name) ||
          state.tier?.options.find((item) => option.type === 'discount' ? item.type === 'discount' : item.type !== 'discount') || null;
        if (state.selectedGift) {
          try {
            window.localStorage.setItem(MODE_STORAGE_KEY, state.selectedGift.type === 'discount' ? 'discount' : 'gift');
            if (state.tierIndex === 0 && state.selectedGift.type !== 'discount') {
              window.localStorage.setItem(CHOICE_STORAGE_KEY, state.selectedGift.name);
            }
          } catch (error) {
            // Selection still persists in Shopify cart attributes.
          }
        }
        await this.syncCampaign(state);
      } catch (error) {
        this.error = 'Sepet okunamadı. Lütfen tekrar dene.';
        console.error('Plantero avantaj seçimi güncellenemedi.', error);
      } finally {
        this.selecting = false;
        this.render(this.getState());
        if (this.pendingRefresh) {
          this.pendingRefresh = false;
          this.scheduleRefresh(30);
        }
      }
    }

    render(state) {
      this.elements.forEach((element) => {
        if (element.isConnected) element.render({ cart: this.cart, ...state, error: this.error, busy: this.syncing || this.selecting || this.refreshing });
      });

      document.querySelectorAll('.pl-hdr__bubble').forEach((bubble) => {
        bubble.textContent = String(this.cart?.item_count || 0);
        bubble.classList.toggle('pl-hide', !this.cart?.item_count);
      });

      const choiceRequired = Boolean(state.tier && state.tier.options.length > 1 && !state.selectedGift);
      document.querySelectorAll('#CartDrawer-Checkout, button[name="checkout"]').forEach((button) => {
        const disabled = choiceRequired || this.syncing || this.selecting || this.refreshing || Boolean(this.error);
        button.disabled = disabled;
        button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        button.classList.toggle('pl-gift-checkout-disabled', disabled);
      });
    }

    formatMoney(cents, showDecimals = true) {
      const currency = this.cart?.currency || this.config?.currency || 'TRY';
      const amount = Number(cents || 0) / 100;
      const fractionDigits = showDecimals && amount % 1 ? 2 : 0;

      if (currency === 'TRY') {
        return `${new Intl.NumberFormat('tr-TR', {
          minimumFractionDigits: fractionDigits,
          maximumFractionDigits: fractionDigits,
        }).format(amount)} TL`;
      }

      return new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', {
        style: 'currency',
        currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
      }).format(amount);
    }
  }

  window.PlanteroGiftCampaign = new PlanteroGiftCampaignController();
  customElements.define('plantero-gift-campaign', PlanteroGiftCampaignElement);
})();
